export class SignInNotfoundError extends Error {
  public constructor() {
    super()

    this.message = 'errors.signInNotfoundError'
  }
}
